import {useTranslation} from 'react-i18next';

import DownloadIcon from '@mui/icons-material/Download';
import {Grid} from '@mui/material';

import {EmpionButton} from '../../../../../../components/EmpionButton/EmpionButton';

type Props = {
  resumeUrl?: string | null;
  /**
   * When there is no resume URL, the action is hidden by default.
   * If true, render the CV button disabled (e.g. talent pool "waiting for CV").
   */
  showDisabledWhenNoResume?: boolean;
};

export const ApplicantResumeDownloadAction = ({resumeUrl, showDisabledWhenNoResume = false}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'companyApplicants.applicantsCard.cardDetails'});

  const hasResume = Boolean(resumeUrl?.trim());

  if (!hasResume && !showDisabledWhenNoResume) {
    return null;
  }

  const handleResumeDownload = () => {
    const url = resumeUrl?.trim();
    if (!url) {
      return;
    }
    window.open(url, '_blank');
  };

  return (
    <Grid sx={{width: 'fit-content', mt: 2}}>
      <EmpionButton onClick={handleResumeDownload} variant='cta' disabled={!hasResume} startIcon={<DownloadIcon />}>
        {t('viewCV')}
      </EmpionButton>
    </Grid>
  );
};
